import React, { useContext } from 'react'
import { Button, Icon } from 'journey-ui'
import classNames from 'classnames'
import { Info, Plus } from 'phosphor-react'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { ToppingRow } from './ToppingRow'
import { RequiresActionPulse } from '../Menu/RequiresActionPulse'

interface Props {
  tile: Tile
}

export function getToppingsInRules(rules: Rule[], form: ItemForm) {
  return form.toppings.filter((t) => rules.find((r) => r.tile_hash_ids.includes(t.tile_hash_id)))
}

export function getTileRules(rules: Rule[], tile: Tile) {
  return rules.filter((r) => r.tile_hash_ids.includes(tile.hash_id))
}

export function isRuleMaxed(rule: Rule, form: ItemForm) {
  return (rule.max > 0 && rule.max <= getToppingsInRules([rule], form).length)
}

export const TileCard: React.FC<Props> = ({ tile }) => {
  const { form, item, setTileModal, rules } = useContext(ItemPageContext)
  const currentToppings = form.toppings.filter((t) => t.tile_hash_id === tile.hash_id)
  const tileRules = rules.filter((r) => r.tile_hash_ids.includes(tile.hash_id))

  /* Do we have any rules which will fail upon adding to cart? */
  const hasInvalidRules = tileRules
    .filter((r) => r.min > getToppingsInRules(tileRules, form).length)
    .length > 0

  return (
    <div className="space-y-2 my-2 bg-gray-50">
      <div className={classNames('flex rounded border-primary items relative p-2 items-center justify-between bg-primary text-primary-contrast')}>
        {hasInvalidRules ? (<RequiresActionPulse />) : null}
        <span className="font-bold">
          {tile.name}
        </span>
        <Button className="size-sm px-3 py-2" onClick={() => setTileModal(tile)}>
          <Icon src={Plus} />
          <span>Add</span>
        </Button>
      </div>

      {currentToppings.map((t) => <ToppingRow key={t.hash_id} topping={t} tile={tile} />)}
    </div>
  )
}
